import React from "react";
import classes from "./ModalBackground.module.scss";
import { ModalBackgroundProps } from "components/v2/Modals/ModalBackground/types/ModalBackgroundProps";

const BlurBackground: React.FC<ModalBackgroundProps> = ({
  children,
  isOpen,
}) => {
  if (isOpen) {
    return (
      <div className={classes["modal-background"]} id="overlay">
        {children}
      </div>
    );
  } else return null;
};
export default BlurBackground;
